import { mapState, mapGetters } from 'vuex';
import config from '@/config/user.env';
const LOAD_URL = {
    'SIT': 'https://an-sit.annto.com/plugin/lots-plugin.umd.js',
    'UAT': 'https://an-uat.annto.com/plugin/lots-plugin.umd.js',
    'VER': 'https://an-ver.annto.com/plugin/lots-plugin.umd.js',
    'PROD': 'https://an.annto.com/plugin/lots-plugin.umd.js'
};

const TrainEnter = {
    render() { },
    name: 'trainEnter',
    data() {
        return {};
    },
    props: {
        env: {
            type: String, // 传入环境变量
            default: 'uat'
        }
    },
    computed: {
        ...mapState({
            userCode: state => state.user.userCode,
            applicationCode: state => state.currentApplicationCode || state.applicationCode // 应用平台编码
        }),
        ...mapGetters(['appList'])
    },
    methods: {
        loadScript() {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = LOAD_URL[this.env.toUpperCase()] || 'https://an.annto.com/plugin/lots-plugin.umd.js';
            document.head.appendChild(script);
            script.onload = () => {
                const ExpressClass = window.lotsPlugin.ExpressClass;
                const params = {
                    apiUrl: config.apiUrl,
                    // apiUrl: 'http://localhost.midea.com:8082',
                    userCode: this.userCode, // 传入用户信息
                    env: this.env, // 传入环境
                    applicationName: this.getSystemName() // 传入系统名称
                };
                const express = new ExpressClass(params);
                express.init();
            };
        },
        /**
         * @description: 获取当前系统名称
         * @return {string} 返回系统名称字符串
         */
        getSystemName() {
            const currentPath = this.appList.find(item => {
                return item.applicationCode === this.applicationCode;
            });
            if (currentPath && currentPath.applicationName) {
                return currentPath.applicationName;
            } else {
                return '';
            }
        }
    },
    created() {
        this.loadScript();
    }
};
export default TrainEnter;